export default {
  title: "There's nothing here",
  subtitle: "Oops ...",
  content: "This page doesn't exists or has been moved",
  go_back: "Return to where you came from",
  go_home: "Return to homepage"
}
